import { HardTermination } from '../shared';

export const CompletedByMinorTermination = () => (
  <HardTermination
    title="For patients under 18, you'll need the help of a parent or guardian"
    body="Please go back and have a parent or a legal guardian complete the assessment for you."
  />
);
